'use client';
import { default as classNames, default as classnames } from 'classnames';
import { Nav } from 'react-bootstrap';
import Helper from '../../../modules/Helper';
import Trans from '../../Common/Trans';

import IconCar from 'app/components/Common/Icons/IconCar';
import IconCruises from 'app/components/Common/Icons/IconCruises';
import IconFlights from 'app/components/Common/Icons/IconFlight';
import IconHotel from 'app/components/Common/Icons/IconHotel';
import { usePathname, useSearchParams } from 'next/navigation';
// @ts-ignore
import store from '../../../../store';

function NavBarLinks() {
	const pathname = usePathname();
	const params = useSearchParams()?.entries();
	const query = Object.fromEntries((params ?? []) as IterableIterator<[PropertyKey, string]>);
	const queryWithLang = query.lng ? `?lng=${query.lng}` : '';

	// @ts-ignore
	const lng = store.getState().base.lng;
	const isRtl = Helper.isRtlLanguage(lng);
	const langCode = Helper.getLanguageCode(lng);
	const queryLangCode = query.lng ? Helper.getLanguageCode(query.lng) : langCode;
	const isEng = queryLangCode === 'en';

	return (
		<Nav
			className={classNames('mr-auto', {
				'flex-row-reverse': isRtl,
			})}
		>
			<Nav.Link
				className={classnames('nav-link', {
					'nav-link_rtl': isRtl,
					active: pathname === '/' || pathname?.includes('/flights'),
				})}
				href={`/flights/${queryWithLang}`}
			>
				<IconFlights /> <Trans i18nKey="navbar.links.flights" />
			</Nav.Link>

			<Nav.Link
				className={classnames('nav-link', {
					'nav-link_rtl': isRtl,
					active: pathname?.includes('/cars'),
				})}
				href={`/cars/${queryWithLang}`}
			>
				<IconCar /> <Trans i18nKey="navbar.links.cars" />
			</Nav.Link>
			<Nav.Link
				className={classnames('nav-link', {
					'nav-link_rtl': isRtl,
					active: pathname?.includes('/hotels'),
				})}
				href={`/hotels/${queryWithLang}`}
			>
				<IconHotel /> <Trans i18nKey="navbar.links.hotels" />
			</Nav.Link>
			{isEng && (
				<Nav.Link
					className={classnames('nav-link', {
						active: pathname === '/cruises',
					})}
					href={`/cruises/${queryWithLang}`}
				>
					<IconCruises /> <Trans i18nKey="navbar.links.cruises" />
				</Nav.Link>
			)}
		</Nav>
	);
}
export default NavBarLinks;
